import React from 'react';
import { setFullscreenLogMessage } from '../../../redux/actions';
import { lzCallApi } from '../../../services/LzApiService';
import { lzDeepVarSet } from '../../../services/LzType';
import { lzLogInfo } from '../../../services/LzUtils';

class LzCrudListingClass extends React.Component {

    constructor(props, crudConfig, modelRef) {
        super(props);
        this.state = {
            records: [],
            total: 0,
            curPage: 0,
            perPage: 10,
            filters: this.getInitFilters(props),
            sortKey: '',
            sortDir: 'asc',
            checkedIds: [],
            showDeleted: false,
        };

        this.crudConfig = crudConfig;
        this.modelRef = modelRef;
    }

    componentDidMount() {
        if (this.crudConfig.isTreeBased) {
            this.loadNodeRecords();
        } else {
            this.loadRecords();
        }
    }

    getInitFilters(props) {
        return {};
    }

    handleFiltersInput = (name, value) => {
        this.setState({ filters: Object.assign({}, this.state.filters, { [name]: value }) });
    };

    resetFilters() {
        this.setState(
            { filters: this.getInitFilters(this.props) },
            // () => this.loadRecords()
            // since the form is still visible on screen, reset just needs to reset the values and not needed to reload records
            // as that can be done on the filters Apply event
        );
    }

    onSortChange(key, dir) {
        if (this.crudConfig.listingColumns[key].sortable) {
            this.setState({ sortKey: key, sortDir: dir }, () => this.loadRecords());
        }
    }

    onPageChange(pageNo) {
        this.setState({ curPage: pageNo }, () => this.loadRecords());
    }

    onRecordsPerPageChange(recordPerPage) {
        this.setState({ curPage: 0, perPage: recordPerPage }, () => this.loadRecords());
    }

    async loadRecords(runAfterSuccessStateChanged) {
        const { sortKey, sortDir, curPage, perPage, filters, showDeleted } = this.state;

        // Make params to send
        const params = {
            _sort_order: typeof sortKey === 'undefined' || !sortKey || '' === sortKey ? '' : sortKey + ' ' + sortDir,
            _page_index: curPage + 1,
            _page_size: perPage,
            _show_deleted: showDeleted,
        };

        // Add filters to params if any
        for (const key in filters) {
            params[key] = filters[key];
        }

        // Make the api call and get the data
        const data = await lzCallApi(this.crudConfig.ident, params);

        // Load data if call was successful
        if (data && data.data) {
            this.setState({
                records: this.modelRef.parseArray(data.data),
                total: +data.total,
                curPage: +data.current_page - 1,
                perPage: +data.per_page,
                sortKey: data.sort_key,
                sortDir: data.sort_dir,
                checkedIds: [],
            }, () => { if (typeof runAfterSuccessStateChanged === 'function') { runAfterSuccessStateChanged(); } });
        }
    }

    loadNodeRecords = async (dexPath, parentId, runAfterSuccessStateChanged) => {
        const { records, filters, showDeleted } = this.state;

        const parentIdVal = parentId || 0;

        // console.log('LOADING-TREE-NODE', dexPath, parentId, parentIdVal);

        // Make params to send
        const params = {
            parent_id: parentIdVal,
            _show_deleted: showDeleted,
        };

        // Add filters to params if any
        for (const key in filters) {
            params[key] = filters[key];
        }

        // Make the api call and get the data
        const data = await lzCallApi(this.crudConfig.ident, params);

        // Load data if call was successful
        if (data) {
            let updated = records.slice();
            if (parentIdVal > 0) {
                lzDeepVarSet(updated, dexPath, this.modelRef.parseArray(data));
            } else {
                updated = this.modelRef.parseArray(data);
            }
            this.setState({
                records: updated,
                checkedIds: [],
            }, () => { if (typeof runAfterSuccessStateChanged === 'function') { runAfterSuccessStateChanged(); } });
        }
    };

    async exportCsv() {
        // Make the api call and get the data
        const data = await lzCallApi(this.crudConfig.ident, { _exportCsv: 1 });
        lzLogInfo('Export CSV Result', data);
    }

    async importCsv(file) {
        // Make the api call and get the data
        const data = await lzCallApi(this.crudConfig.ident, { _importCsv: 1, _csvFile: file }, 'post');

        lzLogInfo('Import CSV Result', data);

        // Load data if call was successful
        if (data) {
            const reduxDispatch = window.reduxStore.dispatch;
            reduxDispatch(setFullscreenLogMessage(data));
        }
    }

    handleActionIconClick(key, rec) {
        if ('status' === key) {
            this.changeStatus(rec);
        }
        else if ('delete' === key) {
            this.deleteRecord(rec.id);
        }
        else if ('deleted_restore' === key) {
            this.deletedRecordAction(rec.id, 'restore');
        }
        else if ('deleted_purge' === key) {
            this.deletedRecordAction(rec.id, 'purge');
        }
        else {
            console.log('TODO: Handle Action Icon Event', key, rec.id);
        }
    }

    async handleGroupActionIconClick(key, confirmation) {
        const { checkedIds } = this.state;

        // If confirmation msg is provided then first confirm
        if (confirmation && confirmation !== '') {
            if (!window.confirm(confirmation)) {
                return;
            }
        }

        // Make the api call
        const data = await lzCallApi(this.crudConfig.ident + '/0', {
            _action: key,
            ids: checkedIds,
        }, 'patch');

        // Load data if call was successful
        if (data) {
            this.loadRecords();
        }
    }

    handleShowDeletedChange(val) {
        this.setState({ showDeleted: val }, () => this.loadRecords());
    }

    async changeStatus(record) {
        // Make the api call
        const data = await lzCallApi(this.crudConfig.ident + '/' + record.id, {
            _action: 'active',
            is_active: !record.is_active,
        }, 'patch');

        // Load data if call was successful
        if (data) {
            this.loadRecords();
        }
    }

    async deleteRecord(id, confirmed) {
        if (!confirmed) {
            if (!window.confirm('Are you sure you want to delete this record?')) {
                return;
            }
        }

        // Make the api call
        const data = await lzCallApi(this.crudConfig.ident + '/' + id, null, 'delete');

        // Load data if call was successful
        if (data) {
            this.loadRecords();
        }
    }

    async deletedRecordAction(id, action, confirmed) {
        if (!confirmed) {
            if (!window.confirm('Are you sure you want to ' + action + ' this record?')) {
                return;
            }
        }

        // Make the api call
        const data = await lzCallApi(this.crudConfig.ident + '/' + id, { _action: action }, 'delete');

        // Load data if call was successful
        if (data) {
            this.loadRecords();
        }
    }

}

export default LzCrudListingClass;
